export const queryStringToString = (params: URLSearchParams) => {
  const queryString = Array.from(params.keys()).length > 0 ? `?${params.toString()}` : '';
  return queryString;
};
